import contextCreator from "../contextCreator";
import regionsReducer, { initialState } from "./regions.reducer";

// eslint-disable-next-line react-hooks/rules-of-hooks
const [state, dispatch, provider] = contextCreator(
  regionsReducer,
  initialState
);

export const useRegionsState = state;
export const useRegionsDispatch = dispatch;
export const RegionsProvider = provider;
